import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import ListItemIcon from '@mui/material/ListItemIcon';
import MenuItem from '@mui/material/MenuItem';
import { useCallback } from 'react';
export const MenuItemContainer = ({ label, svgIconComponent: SvgIconComponent, disabled, onClick, closeMenu }) => {
    const onClickMenuItem = useCallback(() => {
        closeMenu();
        onClick();
    }, [closeMenu, onClick]);
    return (_jsxs(MenuItem, { onClick: onClickMenuItem, disabled: disabled, dense: true, children: [SvgIconComponent && (_jsx(ListItemIcon, { children: _jsx(SvgIconComponent, { fontSize: 'small' }) })), label] }));
};
